<template>
  <div class="comp-box" :class="{ 'highlight-attrs': hasAttrs, 'highlight-listeners': hasListeners }">
    <span class="layer layer-parent">📦 父组件 MyParent</span>
    <div class="comp-title">
      $attrs 已声明 props 的会被移除
      <span v-if="hasAttrs" class="tip-attrs"> ⬅ 有透传属性</span>
      <span v-if="hasListeners" class="tip-listeners"> ⬅ 有透传事件</span>
    </div>

    <p class="comp-desc">
      本组件声明了 props: <code>['placeholder']</code><br>
      <strong style="color:#1890ff;">$attrs</strong> =
      <code>{{ attrsSummary }}</code><br>
      <strong style="color:#722ed1;">$listeners</strong> =
      <code>{{ listenersSummary }}</code>
    </p>

    <!-- 将剩余的 $attrs 和 $listeners 透传给子组件 -->
    <my-child
      v-bind="$attrs"
      v-on="$listeners"
      :inner-msg="'来自父组件的数据'"
    />
  </div>
</template>

<script>
import MyChild from './MyChild.vue'

export default {
  name: 'MyParent',
  components: {
    MyChild
  },
  props: ['placeholder'], // 只声明 placeholder, 其余进 $attrs
  computed: {
    hasAttrs() {
      return Object.keys(this.$attrs).length > 0
    },
    hasListeners() {
      return Object.keys(this.$listeners).length > 0
    },
    attrsSummary() {
      return JSON.stringify(this.$attrs)
    },
    listenersSummary() {
      return Object.keys(this.$listeners).join(', ') || '(无)'
    }
  }
}
</script>

<style scoped>
.comp-box {
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  position: relative;
  transition: border-color .25s;
}

.comp-box.highlight-attrs {
  border-color: #1890ff;
  background: #e6f7ff;
}

.comp-box.highlight-listeners {
  border-color: #722ed1;
  background: #f9f0ff;
}

.layer {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.layer-parent {
  background: #fff7e6;
  color: #d46b08;
}

.comp-title {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
}

.tip-attrs {
  color: #1890ff;
  font-size: 12px;
}

.tip-listeners {
  color: #722ed1;
  font-size: 12px;
}

.comp-desc {
  font-size: 13px;
  margin-bottom: 8px;
  color: #555;
}

.comp-desc code {
  background: var(--surface-2);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #c7254e;
}
</style>
